import { Link } from 'react-router-dom';
import type { TVSeries } from '@/mocks/types';

interface TVCardProps {
  series: TVSeries;
  size?: 'normal' | 'large';
}

export default function TVCard({ series, size = 'normal' }: TVCardProps) {
  return (
    <Link
      to={`/article/${series.id}`}
      className="group block cursor-pointer"
    >
      <div
        className={`relative overflow-hidden rounded-lg ${
          size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
        }`}
      >
        <img
          src={series.coverImage}
          alt={`${series.title} - ${series.subtitle}`}
          title={`${series.title} ${series.subtitle} 高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-white rounded-md">
            {series.rating}
          </span>
        </div>
        {series.status === '更新中' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-white rounded-md">
              {series.status}
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-white text-sm font-semibold truncate">
            {series.title}
          </h3>
          <p className="text-white/70 text-xs mt-0.5">
            {series.episodes}集 · {series.region}
          </p>
        </div>
      </div>
    </Link>
  );
}